if (typeof ProductImageZoom !== 'function') {
  class ProductImageZoom extends HTMLElement {
    constructor() {
      super();
      
      // Find parent container and image
      this.container = this.closest('.product-gallery-item');
      this.productImage = this.container.querySelector('img');
      
      // Set initial state
      this.zoomEnabled = false;
      
      // Create and set up container zoom elements
      this.setupContainerZoom();
      
      // Create mobile lightbox if it doesn't exist
      this.setupMobileLightbox();
      
      // Bind event handlers
      this.onMouseMoveBinded = this.onMouseMove.bind(this);
      this.onContainerClickBinded = this.onContainerClick.bind(this);
      
      // Add click event to the entire container instead of just the zoom button
      this.container.addEventListener('click', this.onContainerClickBinded);
    }
    
    setupContainerZoom() {
      // Create zoom result container
      this.zoomResult = document.createElement('div');
      this.zoomResult.classList.add('product-zoom-result');
      this.zoomResult.style.display = 'none';
      this.zoomResult.style.position = 'absolute';
      this.zoomResult.style.top = '0';
      this.zoomResult.style.left = '0';
      this.zoomResult.style.width = '100%';
      this.zoomResult.style.height = '100%';
      this.zoomResult.style.backgroundSize = '200%';
      this.zoomResult.style.backgroundRepeat = 'no-repeat';
      this.zoomResult.style.pointerEvents = 'none';
      this.zoomResult.style.zIndex = '2';
      this.container.style.position = 'relative';
      this.container.appendChild(this.zoomResult);
    }
    
    setupMobileLightbox() {
      if (!document.getElementById('mobile-zoom')) {
        this.mobileZoom = document.createElement('div');
        this.mobileZoom.id = 'mobile-zoom';
        this.mobileZoom.innerHTML = `
          <div class="mobile-zoom-container">
            <img />
            <span class="mobile-zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
          </div>
          <div class="mobile-zoom__overlay"></div>
        `;
        document.body.appendChild(this.mobileZoom);
        
        // Style the mobile zoom
        this.mobileZoom.style.position = 'fixed';
        this.mobileZoom.style.top = '0';
        this.mobileZoom.style.left = '0';
        this.mobileZoom.style.width = '100%';
        this.mobileZoom.style.height = '100%';
        this.mobileZoom.style.backgroundColor = 'rgba(0,0,0,0.9)';
        this.mobileZoom.style.zIndex = '9999';
        this.mobileZoom.style.display = 'none';
        this.mobileZoom.style.opacity = '0';
        this.mobileZoom.style.transition = 'opacity 0.3s ease';
        
        const container = this.mobileZoom.querySelector('.mobile-zoom-container');
        container.style.position = 'absolute';
        container.style.top = '50%';
        container.style.left = '50%';
        container.style.transform = 'translate(-50%, -50%)';
        container.style.width = '90vw';
        container.style.maxWidth = '90vw';
        container.style.maxHeight = '90%';
        
        const img = container.querySelector('img');
        img.style.maxWidth = '100%';
        img.style.maxHeight = '90vh';
        img.style.objectFit = 'contain';
        img.style.transition = 'opacity 0.2s';
        
        const exit = container.querySelector('.mobile-zoom__exit');
        exit.style.position = 'absolute';
        exit.style.bottom = '1rem';
        exit.style.right = '1rem';
        exit.style.color = 'white';
        exit.style.fontSize = '24px';
        exit.style.cursor = 'pointer';
        exit.style.zIndex = '10';
        exit.addEventListener('click', this.closeMobileZoom.bind(this));
        
        // Add click handler to overlay for closing
        const overlay = this.mobileZoom.querySelector('.mobile-zoom__overlay');
        overlay.style.position = 'absolute';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.zIndex = '1';
        overlay.addEventListener('click', this.closeMobileZoom.bind(this));
      }
      
      this.mobileZoom = document.getElementById('mobile-zoom');
    }
    
    disconnectedCallback() {
      // Remove event listeners when element is removed from DOM
      this.container.removeEventListener('mousemove', this.onMouseMoveBinded);
      this.container.removeEventListener('click', this.onContainerClickBinded);
    }
    
    enableZoom() {
      // Use the current displayed image - no need to reload
      const currentImageSrc = this.productImage.currentSrc || this.productImage.src;
      this.zoomResult.style.backgroundImage = `url(${currentImageSrc})`;
      
      // Show zoom result
      this.zoomResult.style.display = 'block';
      
      // Add mouse move listener
      this.container.addEventListener('mousemove', this.onMouseMoveBinded);
      
      // Add active class for styling
      this.container.classList.add('zoom-active');
    }
    
    disableZoom() {
      // Hide zoom result
      this.zoomResult.style.display = 'none';
      
      // Remove mouse move listener
      this.container.removeEventListener('mousemove', this.onMouseMoveBinded);
      
      // Remove active class
      this.container.classList.remove('zoom-active');
    }
    
    onMouseMove(e) {
      if (this.isMobile() || !this.zoomEnabled) return;
      
      // Get container dimensions
      const rect = this.container.getBoundingClientRect();
      
      // Calculate cursor position as percentage of container
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      
      // Move background image in zoom result
      this.zoomResult.style.backgroundPosition = `${x * 100}% ${y * 100}%`;
    }
    
    onContainerClick(e) {
      if (this.isMobile()) {
        // Prepare for opening the lightbox
        const currentImageSrc = this.productImage.currentSrc || this.productImage.src;
        const img = this.mobileZoom.querySelector('img');
        
        // Completely hide the image until fully loaded
        img.style.display = 'none';
        
        // First make the container visible but with opacity 0
        this.mobileZoom.style.display = 'block';
        this.mobileZoom.style.opacity = '0';
        
        // Preload the image in memory before showing anything
        const preloader = new Image();
        
        preloader.onload = () => {
          // Image is fully loaded in memory, now set it as our source
          img.src = currentImageSrc;
          img.style.display = 'block';
          
          // Show the lightbox with the fully loaded image
          requestAnimationFrame(() => {
            this.mobileZoom.style.opacity = '1';
            document.body.style.overflow = 'hidden';
          });
        };
        
        // Start loading the image
        preloader.src = currentImageSrc;
      } else {
        // Toggle zoom mode for this specific image
        this.zoomEnabled = !this.zoomEnabled;
        
        // Disable zoom on all other images
        if (this.zoomEnabled) {
          // First disable all zooms
          document.querySelectorAll('product-image-zoom').forEach(zoom => {
            if (zoom !== this) {
              zoom.zoomEnabled = false;
              zoom.disableZoom();
            }
          });
          
          this.enableZoom();
        } else {
          this.disableZoom();
        }
      }
    }
    
    closeMobileZoom() {
      this.mobileZoom.style.opacity = '0';
      
      setTimeout(() => {
        this.mobileZoom.style.display = 'none';
        document.body.style.overflow = ''; // Restore scrolling
      }, 300);
    }
    
    isMobile() {
      return document.body.classList.contains('touch') || 
             document.body.classList.contains('touchevents') ||
             window.innerWidth < 768;
    }
  }

  if (typeof customElements.get('product-image-zoom') == 'undefined') {
    customElements.define('product-image-zoom', ProductImageZoom);
  }
}